import { render, staticRenderFns } from "./InfoView.vue?vue&type=template&id=0d58ac90&scoped=true"
import script from "./InfoView.vue?vue&type=script&lang=js"
export * from "./InfoView.vue?vue&type=script&lang=js"
import style0 from "./InfoView.vue?vue&type=style&index=0&id=0d58ac90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58ac90",
  null
  
)

export default component.exports